<template>
  <div>
    <label for="bookingTimeSelected"
      >Time<span v-if="required" class="required">*</span></label
    >
    <multiselect
      id="bookingTimeSelected"
      v-model="time"
      :options="times"
      label="text"
      track-by="id"
      :disabled="setDisable"
      style="margin: 0.6rem 0 0"
    >
    </multiselect>
  </div>
</template>

<script>
import BookingService from "services/api/booking.service";
import { assembleDropdown } from "@/utils/dropdown";
import { emitLoadingStart, emitLoadingDone } from "@/utils/loading";

export default {
  name: "BookingTimeDropdown",
  props: {
    value: { type: Object, default: null },
    setDisable: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    bookingId: { type: Number, default: null },
    serviceId: { type: Number, default: null },
    storeCode: { type: String, default: null },
    date: { type: String, default: null },
  },
  data() {
    return {
      time: this.value,
      times: [],
    };
  },
  created() {
    if (this.serviceId && this.storeCode && this.date) {
      this.getTimes(this.bookingId, this.serviceId, this.storeCode, this.date);
    }
  },
  watch: {
    time(newValue) {
      this.$emit("setTime", newValue);
    },
    value(newValue) {
      this.time = newValue;
    },
    times(newValue) {
      this.$emit("setTimes", newValue);
    },
    serviceId(newServiceId) {
      if (newServiceId && this.storeCode && this.date) {
        this.getTimes(this.bookingId, newServiceId, this.storeCode, this.date);
      } else {
        this.clearTimes();
      }
    },
    storeCode(newStoreCode) {
      if (newStoreCode && this.serviceId && this.date) {
        this.getTimes(this.bookingId, this.serviceId, newStoreCode, this.date);
      } else {
        this.clearTimes();
      }
    },
    date(newDate) {
      if (newDate && this.serviceId && this.storeCode) {
        this.getTimes(this.bookingId, this.serviceId, this.storeCode, newDate);
      } else {
        this.clearTimes();
      }
    },
  },
  methods: {
    async getTimes(bookingId, serviceId, storeCode, date) {
      try {
        emitLoadingStart(this);
        await BookingService.getTimes({
          bookingId: bookingId,
          serviceId: serviceId,
          storeCode: storeCode,
          date: date,
        })
          .then(async (res) => {
            this.times = assembleDropdown(await res.data.items);
          })
          .catch((error) => {
            console.log("Error: ", error);
          });
      } catch (error) {
        console.log("Error: ", error);
      }
      emitLoadingDone(this);
    },
    clearTimes() {
      this.times = [];
    },
  },
};
</script>
